/* THE PAW EDIT™ cart page script (sections/paw-edit-cart.liquid). Loaded after paw-edit.js.
   Quantity, remove and the order note use Shopify's AJAX cart; after each change the
   [data-swap] regions are re-rendered through the Section Rendering API, so prices,
   discounts and totals always come from Shopify rather than being recalculated here. */
(function () {
  const root = document.getElementById('pawCart');
  if (!root) return;
  const $ = (s, el = document) => el.querySelector(s);
  const $$ = (s, el = document) => [...el.querySelectorAll(s)];
  const ROOT = (root.dataset.root || '/').replace(/\/?$/, '/');
  const SECTION = root.dataset.section;
  const JSON_HEADERS = { 'Content-Type': 'application/json', Accept: 'application/json' };
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  let queue = Promise.resolve();

  const say = msg => { const s = $('#cartLiveStatus'); if (s) { s.textContent = ''; setTimeout(() => { s.textContent = msg; }, 50); } };

  /* Keep the header badge in step with the cart */
  function badge(cart) {
    const c = $('#cartCount'); if (!c) return;
    c.textContent = cart.item_count; c.classList.toggle('has-items', cart.item_count > 0);
    const b = $('#cartOpen'); if (b) b.setAttribute('aria-label', `Open cart, ${cart.item_count} item${cart.item_count === 1 ? '' : 's'}`);
  }

  /* Re-render the cart regions from Shopify; reload when the cart flips between empty and filled */
  async function rerender(focus) {
    const r = await fetch(`${ROOT}cart?section_id=${encodeURIComponent(SECTION)}`, { credentials: 'same-origin' });
    if (!r.ok) { location.reload(); return; }
    const doc = new DOMParser().parseFromString(await r.text(), 'text/html');
    const fresh = doc.getElementById('pawCart');
    if (!fresh || fresh.dataset.empty !== root.dataset.empty) { location.reload(); return; }
    $$('[data-swap]', root).forEach(old => {
      const next = fresh.querySelector(`[data-swap="${old.dataset.swap}"]`);
      next ? old.replaceWith(document.importNode(next, true)) : old.remove();
    });
    $$('.cline', root).forEach(l => l.style.animation = 'none');   // no entrance animation on refresh
    if (focus) focus();
    observeSummary();
  }

  /* Change a line's quantity (0 removes it) */
  function change(line, quantity) {
    const key = line.dataset.key, title = ($('.cline__title', line) || {}).textContent || 'Item';
    const act = document.activeElement && document.activeElement.dataset ? document.activeElement.dataset.act : '';
    line.classList.add('is-busy');
    queue = queue.then(async () => {
      try {
        const r = await fetch(ROOT + 'cart/change.js', { method: 'POST', headers: JSON_HEADERS, credentials: 'same-origin', body: JSON.stringify({ id: key, quantity }) });
        const data = await r.json().catch(() => ({}));
        if (!r.ok) {
          line.classList.remove('is-busy');
          const err = $('[data-err]', line); err.textContent = data.description || data.message || 'Sorry, that quantity is not available.'; err.hidden = false;
          const input = $('[data-act="qty"]', line); if (input) input.value = input.defaultValue;
          say(err.textContent);
          return;
        }
        badge(data);
        const still = (data.items || []).some(i => i.key === key);
        await rerender(() => {
          const same = still && $(`.cline[data-key="${CSS.escape(key)}"]`, root);
          const target = same ? (act && $(`[data-act="${act}"]`, same)) || $('[data-act="qty"]', same) : $('#cartPageTitle');
          if (target) target.focus({ preventScroll: !!same });
        });
        say(still ? `${title} quantity updated to ${quantity}.` : `${title} removed from your cart.`);
      } catch (e) {
        line.classList.remove('is-busy');
        say('Connection problem. Please try again.');
      }
    });
  }

  root.addEventListener('click', e => {
    const el = e.target.closest('[data-act]'); if (!el) return;
    const line = el.closest('.cline'); if (!line) return;
    const input = $('[data-act="qty"]', line), q = parseInt(input.value, 10) || 0;
    if (el.dataset.act === 'inc') change(line, q + 1);
    if (el.dataset.act === 'dec') change(line, Math.max(0, q - 1));
    if (el.dataset.act === 'remove') { e.preventDefault(); change(line, 0); }
  });
  root.addEventListener('change', e => {
    const input = e.target.closest('[data-act="qty"]'); if (!input) return;
    const q = Math.max(0, parseInt(input.value, 10) || 0);
    if (String(q) !== input.defaultValue) change(input.closest('.cline'), q);
  });
  root.addEventListener('keydown', e => {
    // Enter in a quantity box applies the change instead of submitting the form to checkout
    if (e.key === 'Enter' && e.target.matches('[data-act="qty"]')) { e.preventDefault(); e.target.blur(); }
  });

  /* Order note: saved as the shopper types */
  const note = $('#cartNote');
  if (note) {
    let t;
    note.addEventListener('input', () => {
      clearTimeout(t); $('#cartNoteStatus').textContent = '';
      t = setTimeout(async () => {
        try {
          const r = await fetch(ROOT + 'cart/update.js', { method: 'POST', headers: JSON_HEADERS, credentials: 'same-origin', body: JSON.stringify({ note: note.value }) });
          $('#cartNoteStatus').textContent = r.ok ? 'Note saved' : 'Could not save the note. It will still be sent at checkout.';
        } catch (e) { $('#cartNoteStatus').textContent = 'Could not save the note. It will still be sent at checkout.'; }
      }, 600);
    });
  }

  /* Items added from the recommendations (quick add / quick view) refresh the page */
  document.addEventListener('cart:updated', () => { queue = queue.then(() => rerender()); });
  addEventListener('pageshow', e => { if (e.persisted) rerender(); });

  /* On the cart page the header cart button goes to the cart itself, not the drawer */
  document.addEventListener('click', e => {
    if (!e.target.closest || !e.target.closest('#cartOpen')) return;
    e.preventDefault(); e.stopPropagation();
    const h = $('#cartPageTitle');
    root.scrollIntoView({ behavior: reduceMotion.matches ? 'auto' : 'smooth' });
    if (h) h.focus({ preventScroll: true });
  }, true);

  /* Mobile checkout bar: shows while the summary's checkout button is off screen */
  let io;
  function observeSummary() {
    const bar = $('#cartbar'), btn = $('#cartCheckout');
    if (io) io.disconnect();
    if (!bar || !btn || !('IntersectionObserver' in window)) return;
    io = new IntersectionObserver(([en]) => {
      const show = !en.isIntersecting && en.boundingClientRect.top > 0;
      bar.classList.toggle('is-show', show); bar.inert = !show;
    });
    io.observe(btn);
  }
  observeSummary();
})();
